import { useEffect } from "react";
import plur from "plur";
import { Button, Flex, ModalV2, QueryLoader, Text } from "@jsq/ds/core";
import { FormSelect } from "@jsq/ds/forms";
import { useFetchCanopyRolesData } from "~/pages/UserAndRoles/CanopyRolesPage/hooks";
import { SPACING } from "~/styles/variables";

export const BulkRemoveRolesModal = ({
  showModal,
  onHide,
  handleSubmit,
  isSubmitting,
  userIds,
}: {
  showModal: boolean;
  onHide: () => void;
  isSubmitting: boolean;
  handleSubmit: (e?: React.FormEvent<HTMLFormElement>) => void;
  userIds: string[];
}) => {
  const { rowData, useGetGroupsQueryResult, refetch } = useFetchCanopyRolesData({ userIds });
  useEffect(() => {
    if (!showModal) return;
    void refetch();
  }, [showModal, refetch]);

  return (
    <ModalV2
      title="Remove Canopy role"
      description={`${userIds.length} ${plur("user", userIds.length)}`}
      isCentered
      show={showModal}
      onHide={onHide}
    >
      <ModalV2.Body>
        <QueryLoader result={useGetGroupsQueryResult}>
          <Flex flexDirection="column" gap={SPACING.MEDIUM}>
            <Flex flexDirection="column" gap={SPACING.X_SMALL}>
              <Text>Canopy roles added to selected users</Text>
              <FormSelect
                full
                multiple
                name="roles"
                placeholder="Select Canopy role..."
                matchFromStart={false}
              >
                <FormSelect.Section>
                  {rowData.map((r) => (
                    <FormSelect.Option value={r.id} key={r.id}>
                      {r.title}
                    </FormSelect.Option>
                  ))}
                </FormSelect.Section>
              </FormSelect>
            </Flex>
            <Text variant="regular-md">
              Are you sure you want to remove the selected Canopy role?
            </Text>
            <Text variant="regular-md">
              Any active work assigned to the selected users will be need to be unassigned.
            </Text>
          </Flex>
        </QueryLoader>
      </ModalV2.Body>
      <ModalV2.Footer>
        <Flex
          flexDirection="row"
          alignItems="center"
          justifyContent="flex-end"
          gap={SPACING.MEDIUM}
        >
          <Button variant="neutral" onClick={onHide}>
            Cancel
          </Button>
          {/** @ts-expect-error the onClick function won't accept the handleSubmit from formik. Another DS issue */}
          <Button onClick={handleSubmit} disabled={isSubmitting} variant="danger">
            {`Remove Canopy role from ${userIds.length} ${plur("user", userIds.length)}`}
          </Button>
        </Flex>
      </ModalV2.Footer>
    </ModalV2>
  );
};
